import React, { useState } from 'react';
import './PasswordRecovery.css';

const PasswordRecovery = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await fetch('/api/password-recovery/send-recovery-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
        setEmail(''); // Limpar o campo
      } else {
        setError(data.error);
      }
    } catch (error) {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="password-recovery-container">
      <div className="password-recovery-card">
        <div className="logo-container">
          <img src="/logo-fks.png" alt="FKS Logo" className="logo" />
        </div>
        
        <h2>Recuperar Senha</h2>
        <p>Digite seu e-mail para receber as instruções de recuperação de senha.</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-mail:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="seu.email@fkslogistics.com.br"
              disabled={loading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}

          <button type="submit" disabled={loading || !email}>
            {loading ? 'Enviando...' : 'Enviar E-mail de Recuperação'}
          </button>
        </form>

        <div className="back-to-login">
          <a href="/login">← Voltar ao Login</a>
        </div>
      </div>
    </div>
  );
};

export default PasswordRecovery;